import * as React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import moment from 'moment'
import DiscountMixin from '../mixins/Discounts'
import cartDomEvents from '../utils/cartDomEvents'

const INTERVAL_SHORT_KEYS = {
  day: 'd',
  week: 'w',
  month: 'M',
  days: 'd',
  weeks: 'w',
  months: 'M'
}

class SnipcartEventListener extends DiscountMixin {
  componentDidMount() {
    this.setListeners()
  }

  onAuthenticationSuccess = () => {
    this.evaluateCartItemsFirstAutoShipDiscount()
    this.resetLocalUserMetrics()
  }

  resetLocalUserMetrics = () => {
    if (localStorage.getItem('sc_metrics')) {
      localStorage.removeItem('sc_metrics')
    }
  }

  setListeners = () => {
    window.Snipcart.subscribe(
      'authentication.success',
      this.onAuthenticationSuccess
    )
    window.Snipcart.subscribe('user.loggedout', () => {
      this.resetLocalUserMetrics()
    })

    window.Snipcart.subscribe('cart.opened', () => {
      cartDomEvents.onHashChange()
      window.onhashchange = cartDomEvents.onHashChange
    })

    window.Snipcart.subscribe('item.removed', item => {
      const cart = window.Snipcart.api.cart.get()
      if (!cart.metadata.discountedProducts) {
        return
      }
      if (!cart.metadata.discountedTotal) {
        return
      }
      let { discountedTotal } = cart.metadata
      if (item.id in cart.metadata.discountedProducts) {
        const productDiscount = cart.metadata.discountedProducts[item.id]
        discountedTotal = Number(discountedTotal) - Number(productDiscount)
        delete cart.metadata.discountedProducts[item.id]
      }

      window.Snipcart.api.cart.metadata({
        ...cart.metadata,
        firstAutoship: true,
        discountedTotal,
        discountedProducts: { ...cart.metadata.discountedProducts }
      })
    })

    window.Snipcart.subscribe('order.completed', async order => {
      if (order.metadata && order.metadata.firstAutoship) {
        localStorage.setItem('sc_metrics', JSON.stringify({ sc: 1 }))
        try {
          const user = window.Snipcart.api.user.current()
          await Promise.all(
            order.items.map(async orderItem => {
              const {
                subscription,
                metadata: {
                  original_price: originalPrice,
                  first_autoship: itemFirstAutoship
                },
                paymentSchedule: { interval, intervalCount },
                quantity
              } = orderItem
              if (
                !subscription ||
                (subscription && !subscription.id) ||
                !itemFirstAutoship
              ) {
                return Promise.resolve()
              }
              const response = await axios.put(
                `${
                  process.env.REACT_APP_SNIPCART_VALIDATOR_DOMAIN
                }api/subscriptions/${subscription.id}`,
                {
                  amount: originalPrice,
                  quantity,
                  schedule: {
                    interval,
                    intervalCount
                  }
                },
                {
                  headers: {
                    Authorization: `Basic ${
                      process.env.REACT_APP_SNIPCART_VALIDATOR_AUTH_TOKEN
                    }`
                  }
                }
              )
              if (response.status === 200) {
                return Promise.resolve(true)
              }
              return Promise.reject(response)
            })
          )
          await axios.post(
            `${
              process.env.REACT_APP_SNIPCART_VALIDATOR_DOMAIN
            }api/register-discount/${user.id}`,
            {},
            {
              headers: {
                Authorization: `Basic ${
                  process.env.REACT_APP_SNIPCART_VALIDATOR_AUTH_TOKEN
                }`
              }
            }
          )
        } catch (error) {
          console.log('error', error)
        }
      }
    })
  }

  render() {
    return <div>{this.props.children}</div>
  }
}

SnipcartEventListener.propTypes = {
  children: PropTypes.node.isRequired
}

export default SnipcartEventListener
